"use strict";

exports.__esModule = true;
exports.default = has;
var _has2 = _interopRequireDefault(require("./_has.js"));
var _toPath = _interopRequireDefault(require("./_toPath.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has(obj, path) {
  path = (0, _toPath.default)(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!(0, _has2.default)(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}